<div
  role="alert"
  aria-atomic="true"
  [attr.aria-hidden]="!toast()"
  class="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 min-w-64 max-w-[calc(100vw-3rem)] px-4 py-[10px] rounded-lg border shadow-lg text-[13px] font-medium leading-snug transition-all duration-300 ease-out select-none"
  [class.opacity-0]="!toast()"
  [class.translate-y-2]="!toast()"
  [class.pointer-events-none]="!toast()"
  [class.bg-success-subtle]="toast()?.level === 'success'"
  [class.border-success]="toast()?.level === 'success'"
  [class.text-success]="toast()?.level === 'success'"
  [class.bg-danger-subtle]="toast()?.level === 'error'"
  [class.border-danger]="toast()?.level === 'error'"
  [class.text-danger]="toast()?.level === 'error'"
  [class.bg-warn-subtle]="toast()?.level === 'warning'"
  [class.border-warn]="toast()?.level === 'warning'"
  [class.text-warn]="toast()?.level === 'warning'"
  [class.bg-primary-subtle]="toast()?.level === 'info'"
  [class.border-primary]="toast()?.level === 'info'"
  [class.text-primary]="toast()?.level === 'info'">

  <svg xmlns="http://www.w3.org/2000/svg" class="size-[18px] shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    @switch (toast()?.level) {
      @case ('success') {
        <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" />
      }
      @case ('error') {
        <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clip-rule="evenodd" />
      }
      @case ('warning') {
        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
      }
      @default {
        <path fill-rule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clip-rule="evenodd" />
      }
    }
  </svg>

  <span class="flex-1">{{ toast()?.message }}</span>

  <button
    type="button"
    (click)="dismiss()"
    aria-label="Cerrar"
    class="shrink-0 opacity-60 hover:opacity-100 transition-opacity cursor-pointer rounded focus:outline-none focus:ring-1 focus:ring-current">
    <svg xmlns="http://www.w3.org/2000/svg" class="size-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
    </svg>
  </button>

</div>
